import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { isAddress } from '../../utils/index.js'
import { WETH_ADDRESS } from '../../constants'

const BAD_IMAGES = {}

const Inline = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
`

const Image = styled.img`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  background-color: white;
  border-radius: 50%;
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.075);
`

export default function TokenLogo({ address, header = false, size = '24px', ...rest }) {
  const [error, setError] = useState(false)
  const [sourceIndex, setSourceIndex] = useState(0)

  useEffect(() => {
    setError(false)
    setSourceIndex(0)
  }, [address])

  if (error || BAD_IMAGES[address]) {
    return (
      <Inline>
        <span {...rest} alt={''} style={{ fontSize: size }} role="img" aria-label="face">
          🤔
        </span>
      </Inline>
    )
  }

  // hard coded fixes for trust wallet api issues
  if (address?.toLowerCase() === '0x5e74c9036fb86bd7ecdcb084a0673efc32ea31cb') {
    address = '0x42456d7084eacf4083f1140d3229471bba2949a8'
  }

  if (address?.toLowerCase() === '0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f') {
    address = '0xc011a72400e58ecd99ee497cf89e3775d4bd732f'
  }

  // prefer local public assets first, then fallbacks
  const checksummed = isAddress(address)
  const localBase = `${process.env.PUBLIC_URL || ''}/assets/${checksummed}`
  const candidates = [
    `${localBase}/logo.png`,
    `${localBase}/logo.svg`,
    `${localBase}/logo.jpg`,
    `${localBase}/logo.jpeg`,
  ]

  // ultimate fallback (legacy trustwallet ethereum path; may not exist on Pax)
  const trustPath = `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/${checksummed}/logo.png`
  const sources = [...candidates, trustPath]

  return (
    <Inline>
      <Image
        {...rest}
        alt={''}
        src={sources[sourceIndex]}
        size={size}
        onError={(event) => {
          event.preventDefault()
          if (sourceIndex + 1 < sources.length) {
            setSourceIndex(sourceIndex + 1)
          } else {
            BAD_IMAGES[address] = true
            setError(true)
          }
        }}
      />
    </Inline>
  )
}
